import React from 'react'
import UserLayout from '../util/UserLayout'

const Wishlist = () => {

    const items = [{},{},{},{}]

  return (
    <UserLayout>
        <div className="row">
            {items.map((item, index)=>(
                <div className="col-md-4 col-6">
                    <div className="card mb-7">
                        {/* Image */}
                        <div className="card-img">
                            {/* Action */}
                            <button className="btn btn-xs btn-circle btn-white-primary card-action card-action-right">
                                <i className="bi bi-x" />
                            </button>
                            {/* Button */}
                            <button className="btn btn-xs btn-block btn-dark card-btn" data-toggle="modal"
                                data-target="#modalProduct">
                                <i className="bi bi-eye mr-2 mb-1" /> Quick View
                            </button>
                            {/* Image */}
                            <img className="card-img-top" src="/assets/img/products/product-6.jpg" alt="..." />
                        </div>
                        {/* Body */}
                        <div className="card-body font-weight-bold text-center">
                            <a className="text-body" href="product.html">Cotton floral print Dress</a> <br />
                            <span className="text-muted">$40.00</span>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </UserLayout>
  )
}

export default Wishlist